import * as _ from 'lodash';
import { Component, OnInit, ViewChild } from '@angular/core';
import { CardPublished } from '../../shared/models/card.model';
import { CATEGORIES, SocketService } from '../../shared/services/socket.service';
import { Router } from '@angular/router';
import { CountdownTimerComponent } from '../../shared/components/countdown-timer/countdown-timer.component';
import { ApiService } from '../../shared/services/api.service';
import { StorageService } from '../../shared/services/storage.service';
import { GameService, GameState } from '../../shared/services/game.service';
import { SettingsResult } from '../../shared/models/game-settings.model';
import { GroupsService } from '../../shared/services/groups-service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

import { isNullOrUndefined } from "util";
import { MatDialog } from '@angular/material';
import { DialogGameResultComponent } from './dialog-game-result/dialog-game-result.component';

@Component({
  selector: 'app-digi-game',
  templateUrl: './digi-game.component.html',
  styleUrls: ['./digi-game.component.scss']
})

export class DigiGameComponent implements OnInit {

  @ViewChild(CountdownTimerComponent)
  timerComponent: CountdownTimerComponent;
  time: number;

  settings: SettingsResult;

  publishedCards: CardPublished[] = [];
  publishedCardsChanged:  BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  filtered: CardPublished[] = [];
  categories = CATEGORIES;
  currentCategory: string;
  ranks: any;
  scoresToggle = true;

  constructor(
    private socketService: SocketService,
    private apiService: ApiService,
    private storageService: StorageService,
    private router: Router,
    private gameService: GameService,
    public groupsService: GroupsService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    this.initConnection();
    this.publishedCardsChanged.subscribe( (d) => {
      this.updateRanks();
    });
  }

  getSettings() {
    this.storageService.getSessionCode().subscribe((sessionCode) => {
      this.apiService.getSettings(sessionCode)
        .subscribe(data => {
          this.settings = data;

          // GroupService
          this.groupsService.initWithSettings(this.settings);

          this.publishedCards = data.publishedCards;
          this.publishedCards.forEach((card) => {
            card.new = false;
          });

          this.publishedCardsChanged.next(true);
          // Set seconds for clock
          this.timerComponent.time = this.settings.duration * 60;
          this.socketService.requestTimeSync();
          this.currentCategory = 'ALLES';
          this.resetFilter();
        });
    });
  }

  categoryClicked(category: string) {

    this.filter(category);

    this.socketService.filterCategory(this.currentCategory);
  }

  filter(category: string) {
    this.resetFilter();
    if (category === CATEGORIES.ALLES) {
      this.currentCategory = category;
      return this.filtered;
    }
    this.filtered = _.filter(this.publishedCards, (card: CardPublished) => {
      return card.category.toUpperCase() === category;
    });
    this.currentCategory = category;
  }

  private resetFilter() {
    this.filtered.splice(0, this.filtered.length);
    this.filtered = this.filtered.concat(_.orderBy(this.publishedCards, ['publishedAt'], ['desc']));
  }

  private initConnection(): void {
    this.getSettings();

    this.socketService.onCardPublished().subscribe((cardData: CardPublished) => {
      cardData.new = true;
      this.publishedCards.push(cardData);
      this.filter(this.currentCategory);
      this.publishedCardsChanged.next(true);
    });

    this.socketService.onCardUnpublished().subscribe((cardData: CardPublished) => {
      _.remove(this.publishedCards, (card: CardPublished) => {
        return card.id === cardData.id;
      });
      this.filter(this.currentCategory);
      this.publishedCardsChanged.next(true);
    });

    this.socketService.onScoresToggle().subscribe((data: boolean) => {
      console.log('scores toggled:' , data);
      this.scoresToggle = data;
    });

    this.socketService.onFilterCategory().subscribe((data: string) => {
      console.log('filter category:' , data);
      this.filter(data);
    });

    this.socketService.onGameStart().subscribe((data: any) => {
      console.log('game started');
      this.timerComponent.start();
    });

    this.socketService.onGamePause().subscribe(() => {
      console.log('timer paused!');
      this.timerComponent.pause();
    });

    this.socketService.onGameResume().subscribe(() => {
      console.log('timer resumed!');
      this.timerComponent.resume();
    });

    this.socketService.onGameStop().subscribe(() => {
      console.log('game stopped!');
      this.timerComponent.stop();
      this.openDialogGameResult();
    });

    this.socketService.onTimeSync().subscribe( (data) => {
      this.timerComponent.time = data.time;

      if (data.state === GameState.PAUSE) {
        this.timerComponent.pause();
      }

      if (data.state === GameState.START || data.state === GameState.RESUME) {
        this.timerComponent.start();
      }
    });
  }

  getScoreForDifficulty(difficulty: number): number {
    const difficultyMultipliers = [1.0, 1.1, 1.2, 1.3, 1.4];
    return Math.round(100 * difficultyMultipliers[difficulty]);
  }


  updateRanks() {
    const rankData = {};
    this.groupsService.groupItems.forEach( (i) => {
      rankData[i.id] = {
        score: 0,
        group: i.id,
        label: i.label,
        name: i.name,
        color: i.color
      };
    });

    this.publishedCards.forEach( (it) => {
      const groupLabel = it.group;
      rankData[groupLabel].score += this.getScoreForDifficulty(it.difficulty);

    });
    this.ranks = _.sortBy(rankData, ['score', 'label']).reverse();
  }

  getTotalScore(): number {
    return _.sumBy(this.ranks, 'score');
  }

  openDialogGameResult(): void {
    let dialogRef = this.dialog.open(DialogGameResultComponent, {
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);

      if (!isNullOrUndefined(result)) {
      }

    });
  }
}



// WEBPACK FOOTER //
// ./src/app/digi/digi-game/digi-game.component.ts